import { render } from "./GrayButton.vue?vue&type=template&id=e5a07f9c"
import script from "./GrayButton.vue?vue&type=script&lang=js"
export * from "./GrayButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__